import { createUseStyles } from "react-jss";

const styles = createUseStyles({
  travelerDetails: {
    //
  }
});

export default styles;
